import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { CommonErrorMessage } from '../../../../components/error/CommonErrorMessage';
import { getErrorMessage } from '../../../../utils/errorMessage';

type Props = {
  error: ThrownTypeResponse;
};

export const SearchErrorMessage: FC<Props> = ({ error }) => {
  const intl = useIntl();
  return (
    <CommonErrorMessage error={getErrorMessage(error, intl.formatMessage)} />
  );
};
